import { useEffect, useRef } from 'react';
import { useSnapshot } from 'valtio';

import { StudioModalName } from '@cartwhl/common/stores/navigationStore';

import {
  getWelcomeModalPreviewVariant,
  getWelcomeModalVariant,
  hasSeenWelcomeModal,
} from 'components/modals/WelcomeModal';
import { authStore, navigationStore, userStore } from 'stores';

export default function WelcomeModalAutoOpen() {
  const { authStatus } = useSnapshot(authStore.state);
  const { modal } = useSnapshot(navigationStore.state);
  const { loading, organizationInfo } = useSnapshot(userStore.state);
  const hasAutoOpened = useRef(false);
  const previewVariant = getWelcomeModalPreviewVariant();

  useEffect(() => {
    if (hasAutoOpened.current || modal.type !== '') {
      return;
    }

    if (previewVariant) {
      hasAutoOpened.current = true;
      navigationStore.setModal(StudioModalName.WELCOME);
      return;
    }

    if (
      authStatus !== 'user' ||
      loading ||
      !getWelcomeModalVariant(organizationInfo) ||
      hasSeenWelcomeModal(organizationInfo)
    ) {
      return;
    }

    hasAutoOpened.current = true;
    navigationStore.setModal(StudioModalName.WELCOME);
  }, [authStatus, loading, modal.type, organizationInfo, previewVariant]);

  return null;
}
